import { TypeTagLabel } from "#components/primitive";
import i18n from "#i18n/index";
import {
	DashboardNotificationClassificationEnum,
	DashboardNotificationPaginated,
	DashboardNotificationTagsEnum,
	Pagination,
} from "#resources/api/enterprise-generated";
import { InfiniteData } from "@tanstack/react-query";

const t = i18n.t;

export type NotificationsTabs = "read" | "unread";

export interface NotificationsContextData {
	unreadNotifications?: InfiniteData<DashboardNotificationPaginated>;
	readNotifications?: InfiniteData<DashboardNotificationPaginated>;
	showNotifications: boolean;
	currentTab: NotificationsTabs;
	hasUnreadNotifications: boolean;
	onChangeTabs: (tab: NotificationsTabs) => void;
	onCloseNotifications: () => void;
	onOpenNotifications: () => void;
	onShowMoreReadNotifications: () => void;
	onShowMoreUnreadNotifications: () => void;
}

export const CLASSIFICATION_LABEL: Record<
	DashboardNotificationClassificationEnum,
	string
> = {
	alert: t($ => $.notifications.classification.alert, { ns: "components" }).toUpperCase(),
	soon: t($ => $.comingSoon, { ns: "globalKeys" }).toUpperCase(),
	release: t($ => $.notifications.classification.release, {
		ns: "components",
	}).toUpperCase(),
	warning: t($ => $.notifications.classification.warning, {
		ns: "components",
	}).toUpperCase(),
	other: t($ => $.helpers.humanize.paymentMethod.other, { ns: "org" }).toUpperCase(),
	xmlZipError: t($ => $.notifications.xmlZipError, { ns: "components" }).toUpperCase(),
	xmlZipSuccess: t($ => $.notifications.xmlZipSuccess, {
		ns: "components",
	}).toUpperCase(),
};

export const CLASSIFICATION_TAG_TYPE: Record<
	DashboardNotificationClassificationEnum,
	TypeTagLabel
> = {
	alert: "error",
	soon: "info",
	release: "primary",
	warning: "warning",
	other: "highlight",
	xmlZipError: "error",
	xmlZipSuccess: "primary",
};

export const LEVEL_LABEL: Record<DashboardNotificationTagsEnum, string> = {
	app: t($ => $.notifications.level.app, { ns: "components" }).toUpperCase(),
	organization: t($ => $.notifications.level.organization, {
		ns: "components",
	}).toUpperCase(),
	place: t($ => $.notifications.level.place, { ns: "components" }).toUpperCase(),
	event: t($ => $.notifications.level.event, { ns: "components" }).toUpperCase(),
	pdv: t($ => $.notifications.level.pdv, { ns: "components" }).toUpperCase(),
};

export const DEFAULT_PAGINATION: Pagination = {
	currentPage: 1,
	perPage: 10,
};
